import { StackProps, styled } from '@mui/material';
import { Stack } from '@monorepo/nova-ui';

export const PurchaseLayout = styled(Stack)<StackProps>(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',
  background: theme.palette.background.gradient,
  height: '100vh',
}));
